import actions from './actions';
import mutations from './mutations';
import getters from './getters';

const state = {
  currentBoard: {}
};

export default {
  state,
  actions,
  mutations,
  getters
};
